import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../types';
import { JobExecutionHistoryState, JobExecutionHistory, SearchSelectBoxItems } from './types';
import * as types from './mutation-types';

// エラーをクリアする
const resetErrors = (state: JobExecutionHistoryState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorTitle = undefined;
    searchState.errorDetails = undefined;

    const searchSelectState = state.searchSelect;
    searchState.error = false;
    searchState.errorTitle = undefined;
    searchState.errorDetails = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const retryState = state.retry;
    retryState.error = false;
    retryState.errorTitle = undefined;
    retryState.errorDetails = undefined;

    const csvState = state.csv;
    csvState.error = false;
    csvState.errorTitle = undefined;
    csvState.errorDetails = undefined;
};
export const mutations: MutationTree<JobExecutionHistoryState> = {
    // 検索系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; job_execution_histories: Array<JobExecutionHistory> }) {
        state.count = payload.count;
        state.lists = payload.job_execution_histories;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const searchState = state.search;
        searchState.errorTitle = payload.errorTitle;
        searchState.errorDetails = payload.errorDetails;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // 処理種別とステータスを取得系
    [types.SEARCH_SELECT_ITEMS_START](state) {
        resetErrors(state);
        const searchSelectState = state.searchSelect;
        searchSelectState.isProcessing = true;
    },

    [types.SEARCH_SELECT_ITEMS_SUCCESS](state, payload: SearchSelectBoxItems) {
        state.searchSelectItems = payload;

        const searchSelectState = state.searchSelect;
        searchSelectState.isProcessing = false;
    },

    [types.SEARCH_SELECT_ITEMS_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const searchSelectState = state.searchSelect;
        searchSelectState.errorTitle = payload.errorTitle;
        searchSelectState.errorDetails = payload.errorDetails;
        searchSelectState.error = true;
        searchSelectState.isProcessing = false;
    },

    // ジョブ実行詳細情報参照系
    [types.SHOW_START](state) {
        resetErrors(state);
        const showState = state.show;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: JobExecutionHistory) {
        state.details = payload;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // ジョブリトライ系
    [types.RETRY_START](state) {
        resetErrors(state);
        const retryState = state.retry;
        retryState.isProcessing = true;
    },

    [types.RETRY_SUCCESS](state) {
        const retryState = state.retry;
        retryState.isProcessing = false;
    },

    [types.RETRY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const retryState = state.retry;
        retryState.errorTitle = payload.errorTitle;
        retryState.errorDetails = payload.errorDetails;
        retryState.error = true;
        retryState.isProcessing = false;
    },

    // CSV出力系
    [types.CSV_OUTPUT_START](state) {
        resetErrors(state);
        const csvState = state.csv;
        csvState.isProcessing = true;
    },

    [types.CSV_OUTPUT_SUCCESS](state) {
        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CSV_OUTPUT_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const csvState = state.csv;
        csvState.errorTitle = payload.errorTitle;
        csvState.errorDetails = payload.errorDetails;
        csvState.error = true;
        csvState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const searchSelectState = state.searchSelect;
        searchSelectState.isProcessing = false;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const retryState = state.retry;
        retryState.isProcessing = false;

        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.lists = undefined;
        state.count = 0;
        state.details = undefined;
    },
};
